// extracted by mini-css-extract-plugin
export default {"myModal":"MyModal_myModal__AHQMj","myModal__content":"MyModal_myModal__content__oEDTI","active":"MyModal_active__bvyKr"};